//CONSTANTS_USE_PROPER_CASE
export const cellphoneCodes = [
  "050",
  "051",
  "052",
  "053",
  "054",
  "055",
  "057",
  "058",
];

export const homePhoneCodes = [
  "",
  "02",
  "03",
  "04",
  "08",
  "09",
  "072",
  "073",
  "074",
  "076",
  "077"
];
